import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import './style.css'
import { useThemeStore } from './stores/theme'
import { useAuthStore } from './stores/auth'

const app = createApp(App)
app.use(createPinia())
app.use(router)

// Initialize theme before mount
const themeStore = useThemeStore()
themeStore.applyTheme()

// Initialize auth (cookie-based SSO) lazily for non-public routes
const authStore = useAuthStore()
let authInitPromise: Promise<boolean> | null = null

router.beforeEach(async (to) => {
  if (to.meta.public) return
  if (!authInitPromise) {
    authInitPromise = authStore.init()
  }
  await authInitPromise
})

app.mount('#app')
